import React from 'react';
import { Link } from 'react-router-dom';
import './ProjectCard.css';

const ProjectCard = ({ project, full = false, onMouseEnter, onMouseLeave }) => {
  const isInternal = project.url?.startsWith('/');
  const Wrapper = isInternal ? Link : 'a';
  const wrapperProps = isInternal
    ? { to: project.url }
    : { href: project.url, target: '_blank', rel: 'noopener noreferrer' };

  return (
    <Wrapper
      className={`project-card${full ? ' project-card--full' : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...wrapperProps}
    >
      <div className="project-image-wrapper">
        {project.image
          ? <img src={project.image} alt={project.title} className="project-image" style={project.imagePosition ? { objectPosition: project.imagePosition } : undefined} />
          : <div className="project-image-placeholder placeholder-gradient"><span>{project.icon}</span></div>
        }
      </div>
      <div className="project-info">
        <h3>{project.title}</h3>
        {project.year && <p className="case-study-meta">{project.year}</p>}
        <p className="project-description">{project.description}</p>
      </div>
    </Wrapper>
  );
};

export default ProjectCard;
